import { useMemo, useState } from 'react';
import dynamic from 'next/dynamic';
import ProductGalleryBlockModalButton from '@features/cms/components/collections/ProductGalleryBlock/ProductGalleryBlockModalButton/ProductGalleryBlockModalButton';
import ProductGalleryBlockModal from '@features/cms/components/collections/ProductGalleryBlock/ProductGalleryBlockModal/ProductGalleryBlockModal';
import styles from '@features/cms/components/inspirations/InspirationProductGallerySingle/InspirationProductGallerySingle.styles';
import useBodyOverflow from '@hooks/useBodyOverflow';
import ResponsiveImage from '@components/ResponsiveImage/ResponsiveImage';
const DynamicModalRootPortal = dynamic(() => import('@components/ModalRootPortal/ModalRootPortal'), {
  ssr: false
});
const ProductImageSingle = ({
  products,
  isRightText,
  variant,
  image,
  imageWithBlur
}) => {
  const [isHoverImage, setIsHoverImage] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const imageSource = imageWithBlur || {
    image
  };
  const modalData = {
    products,
    image: imageSource,
    itemId: 'singleImage'
  };
  useBodyOverflow(isModalOpen, 'productImageSingle', false, true);
  const renderImage = useMemo(() => <ResponsiveImage image={imageSource.image} blur={imageSource.blur} alt="" />, [imageSource]);
  return products.length > 0 ? <>
      <button type="button" sx={styles.imageWrapper(variant)} onMouseEnter={() => {
      setIsHoverImage(true);
    }} onMouseLeave={() => {
      setIsHoverImage(false);
    }} onClick={() => setModalOpen(true)} className="photo_with_products" data-testid="productImageSingle-button">
        <div sx={styles.singleImageBox(isRightText, variant)}>
          {renderImage}
          <ProductGalleryBlockModalButton isExpanded={isHoverImage} />
        </div>
      </button>
      {isModalOpen && <DynamicModalRootPortal>
          <ProductGalleryBlockModal isActive={isModalOpen} slide={modalData} onClose={() => setModalOpen(false)} />
        </DynamicModalRootPortal>}
    </> : <div sx={styles.imageWrapper(variant)}>
      <div sx={styles.singleImageBox(isRightText, variant)}>{renderImage}</div>
    </div>;
};
export default ProductImageSingle;